<template>
  <div>
    <v-toolbar class="white">
      <v-toolbar-title v-text="title"></v-toolbar-title>
    </v-toolbar>
    <v-content>
      <section>
        <v-parallax src=".././img/images/edificios.jpg" height="600">
          <v-layout column align-center justify-center class="white--text">
            <img src=".././assets/logo.png" alt="Gestión Ayudas" height="200" />
            <h1 class="white--text mb-2 display-1 text-xs-center">
              Gestión Ayudas
            </h1>
            <div class="subheading mb-3 text-xs-center"></div>
            <v-btn class="blue lighten-2 mt-5" dark large href="/user">
              Entrar
            </v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <!-- <section>
            <v-layout
            column
            wrap
            class="my-5"
            align-center
            >
            <v-flex xs12 sm4 class="my-3">
                <div class="text-xs-center">
                <h2 class="headline">The best way to start developing</h2>
                <span class="subheading">
                    Cras facilisis mi vitae nunc 
                </span>
                </div>
            </v-flex>
            <v-flex xs12>
                <v-container grid-list-xl>
                <v-layout row wrap align-center>
                    <v-flex xs12 md4>
                    <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                        <v-icon x-large class="blue--text text--lighten-2">color_lens</v-icon>
                        </v-card-text>
                        <v-card-title primary-title class="layout justify-center">
                        <div class="headline text-xs-center">Material Design</div>
                        </v-card-title>
                        <v-card-text>
                        Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. 
                        Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. 
                        Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. 
                        </v-card-text>
                    </v-card>
                    </v-flex>
                    <v-flex xs12 md4>
                    <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                        <v-icon x-large class="blue--text text--lighten-2">flash_on</v-icon>
                        </v-card-text>
                        <v-card-title primary-title class="layout justify-center">
                        <div class="headline">Fast development</div>
                        </v-card-title>
                        <v-card-text>
                        Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. 
                        Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. 
                        Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. 
                        </v-card-text>
                    </v-card>
                    </v-flex>
                    <v-flex xs12 md4>
                    <v-card class="elevation-0 transparent">
                        <v-card-text class="text-xs-center">
                        <v-icon x-large class="blue--text text--lighten-2">build</v-icon>
                        </v-card-text>
                        <v-card-title primary-title class="layout justify-center">
                        <div class="headline text-xs-center">Completely Open Sourced</div>
                        </v-card-title>
                        <v-card-text>
                        Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. 
                        Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. 
                        Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. 
                        </v-card-text>
                    </v-card>
                    </v-flex>
                </v-layout>
                </v-container>
            </v-flex>
            </v-layout>
        </section> -->

      <!-- <section>
            <v-parallax src=".././assets/section.jpg" height="380">
            <v-layout column align-center justify-center>
                <div class="headline white--text mb-3 text-xs-center">Web development has never been easier</div>
                <em>Kick-start your application today</em>
                <v-btn
                class="blue lighten-2 mt-5"
                dark
                large
                href="/pre-made-themes"
                >
                Get Started
                </v-btn>
            </v-layout>
            </v-parallax>
        </section> -->

      <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-5">
            <!-- <v-flex xs12 sm4>
                <v-card class="elevation-0 transparent">
                    <v-card-title primary-title class="layout justify-center">
                    <div class="headline">Contacto</div>
                    </v-card-title>
                    <v-card-text>
                    Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare. 
                    Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. 
                    Nullam in aliquet odio. Aliquam eu est vitae tellus bibendum tincidunt. Suspendisse potenti. 
                    </v-card-text>
                </v-card>
                </v-flex> -->
            <v-flex xs12 sm4 offset-sm1>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Contacto</div>
                </v-card-title>
                <v-card-text>
                  Pronarres Gestión Inmobiliaria S.L.
                </v-card-text>
                <v-list class="transparent">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>900 827 907</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">place</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >Calle González Adalíd 3, Murcia</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">email</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >info@gestionayudas.es</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <v-footer class="blue darken-2">
        <v-layout row wrap align-center>
          <v-flex xs12>
            <div class="white--text ml-3">
              Realizada por
              <a class="white--text" href="" target="_blank"
                >Domingo González</a
              >
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-content>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      title: "Gestión Ayudas"
    };
  },
  created() {
    // this.setConfigApp()
  },
  methods: {
    setConfigApp() {
      this.$store.dispatch("newConfigApp");
    }
  },
  computed: {
    configApp() {
      return this.$store.getters.getConfigApp;
    },
    level() {
      return this.$store.getters.getLevel;
    },
    user() {
      return this.$store.getters.getUser;
    }
  }
};
</script>
